var map = {
	"./Armenia.svg": "6e05",
	"./FaceBook.png": "8319",
	"./Instagram.png": "5f40",
	"./Line.svg": "b7d6",
	"./LinkedIn.png": "5819",
	"./Math.svg": "fdc9",
	"./Music.svg": "afc0",
	"./Rubika.png": "092d",
	"./Shad.png": "54b7",
	"./Soroush.png": "ad6c",
	"./Telegram.png": "77de",
	"./Twitter.png": "1d71",
	"./Türkiye.svg": "b05a",
	"./WhatsApp.png": "8e0f",
	"./Youtube.png": "5e14",
	"./aparat.png": "2569",
	"./appstore.png": "04f4",
	"./cafebazaar.png": "f432",
	"./eitaa.png": "d62a",
	"./german.svg": "215e",
	"./googleplay.png": "c39b",
	"./iels.svg": "d5e1",
	"./myket.png": "37c4",
	"./other.svg": "8b9f",
	"./paper.svg": "de76",
	"./phone.svg": "936a",
	"./qr-code.png": "fd41",
	"./sibapp.png": "f655",
	"./sibche.png": "44c4",
	"./sports.svg": "175d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e507";